import React from 'react'
import { View, ActivityIndicator, Text, StyleSheet } from 'react-native'

// Loader de pantalla completa similar al de validación de sesión (Main.jsx)
// Usar: <LoadingOverlay visible={isLoading} message="Cargando cursos…" />
const LoadingOverlay = ({ visible = false, message = 'Cargando…' }) => {
    if (!visible) return null
    return (
        <View style={styles.container} pointerEvents='none'>
            <ActivityIndicator size='large' color='#999' />
            <Text style={styles.text}>{message}</Text>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: '#fff',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
    },
    text: {
        marginTop: 12,
        color: '#666',
    },
})

export default LoadingOverlay
